<template>
  <div>
    <div class="row" v-if="course">
      <div class="col-12 col-lg-5">
        <div class="row">
          <div class="col-12 col-sm-3 col-lg-5 course-logo-link-div">
            <router-link class="course-logo-link"
                         :to="{ name: 'course.details', params: { slug: course.slug }}">
              <img
                  class="home-kurs-img lazyloaded"
                  style="max-width: 100%;"
                  v-if="course.caticon"
                  :src="course.caticon"
              >

              <img
                  class="home-kurs-img lazyloaded"
                  style="max-width: 100%;"
                  src="@/assets/hometeacher/images/home-kurs-none.png"
                  v-else
              >
            </router-link>
          </div>

          <div class="col-12 col-sm-9 col-lg-7 home-kurs">
            <div class="row">
              <div class="col-12">
                <h2 class="h2kurs pb-2">
                  <img class="easy" :src="require(`@/assets/hometeacher/images/${difficlty}.png`)">
                  <router-link :to="{ name: 'course.details', params: { slug: course.slug }}">
                    {{ course.course }}
                  </router-link>
                </h2>
                <p v-if="languageText">{{ $t('Language') }}: <span class="strong-black">{{ languageText }}</span></p>
                <p v-if="ageText">{{ $t('Age') }}: <span class="strong-black">{{ ageText }}</span></p>
                <p v-if="course.lessonscount">{{ $t('Lessons') }}: <span class="strong-black">{{
                    course.lessonscount
                  }}</span></p>
                <p v-if="course.duration">{{ $t('Lesson_duration') }}: <span
                    class="strong-black">{{ course.duration }}</span></p>
                <p v-if="course.duration_course">{{ $t('Course_duration') }}: <span
                    class="strong-black">{{ course.duration_course }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 kurs kurs-under" v-if="showAdditionalPackage && course.description">
            {{ stripHtml(course.description) }}
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-5 kurs" v-if="showAdditionalPackage">
        <div :class="['dop-pack', {'activated' : activated || course.isAdditionalPackage}]">
          <div class="dop-pack-name">{{ $t('dop_pack_title') }}:</div>
          <div class="dop-pack-item">{{ $t('dop_pack_item_1') }}</div>
          <div class="dop-pack-item">{{ $t('dop_pack_item_2') }}</div>
          <div class="dop-pack-item">{{ $t('dop_pack_item_3') }}</div>
          <div class="dop-pack-item">{{ $t('dop_pack_item_4') }}</div>
          <div class="dop-pack-item">{{ $t('dop_pack_item_5') }}</div>
          <div class="dop-pack-price"
               v-if="course.ordered && course.additional_package_price && !course.isAdditionalPackage">
            <span class="dop-pack-price-value">{{ course.additional_package_price | formatPrice }}</span>
            <span
                class="dop-pack-rub">{{ $t('cur') }}</span>
            <span class="dop-pack-before"
                  v-if="course.additional_package_price_before">{{
                course.additional_package_price_before | formatPrice
              }} {{
                $t('cur')
              }}</span>
          </div>
          <div class="dop-pack-switch switch" v-if="!hideAddSwitch && !course.isAdditionalPackage">
            <label class="switch">
              <input :disabled="hideButton" type="checkbox" v-model="activated"
                     :data-course-id="course.idcourse" data-action="additionalPackageToggle">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-5 kurs" v-else-if="course.description">
        <div class="mt-lg-0 mx-lg-0 mx-3 mt-3">{{ stripHtml(course.description) }}</div>
      </div>

      <div class="col-12 col-lg-5 kurs mt-lg-0 mx-lg-0 mx-3 mt-3" v-else>
        <div class="mt-lg-0 mx-lg-0 mx-3 mt-3">{{ $t('course_description_empty') }}</div>
      </div>

      <div class="col-12 col-lg-2 zapis">
        <base-button @click="order" class="ma-0" v-if="!hideButton"
                     :data-id="course.idcourse"
                     data-model="course"
                     :data-price="price"
                     data-action="order"
                     :data-label="buttonText">
          {{ buttonText }}
        </base-button>
        <base-button @click="demo" class="mt-2 mb-1 demo-button" v-if="demoButtonText"
                     :data-id="course.idcourse"
                     data-model="course"
                     :data-price="price"
                     data-action="demo"
                     :data-label="demoButtonText">
          {{ demoButtonText }}
        </base-button>
        <div v-if="showPrice" :class="{ 'demo': demoButtonText, 'course_ordered_price' :  course.ordered }">
          <div v-if="!course.partial_pay">
            <span class="cena">{{ price | formatPrice }}</span>{{ $t('cur') }}
            <span class="rub" v-if="hasPrevPrice"><s>{{ priceBefore | formatPrice }}{{ $t('cur') }}</s></span>
          </div>
          <div class="cena-partial" v-else>
            {{ $t('ot') }}&nbsp;<span class="cena">{{ course.partial_pay_amount | formatPrice }}</span>{{ $t('cur') }}
            <span class="rub" v-if="hasPrevPrice"><s>{{ priceBefore | formatPrice }}{{ $t('cur') }}</s></span>
          </div>
        </div>
        <div class="course-recurrent-option mt-5" v-if="showRecurrentParam">
          <base-checkbox class="custom-control-alternative danger"
                         :disabled="recurrentParamDisabled"
                         v-model="recurrentParam"
                         @input="recurrentParamUpdate">
            {{ $t('reccurent_notice_course') }}
          </base-checkbox>
        </div>
      </div>
    </div>

    <div class="row" v-if="!lastItem">
      <div class="col-12">
        <div class="land-t-delimeter"></div>
      </div>
    </div>
  </div>
</template>

<script>


import courseApi from "../data/CourseApi";
import numeral from 'numeral';

export default {
  name: "CourseListItem",
  props: {
    title: String,
    course: {
      type: Object,
    },
    lastItem: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    hideAdd: {
      type: Boolean,
      default: false,
    },
    hideAddSwitch: {
      type: Boolean,
      default: false,
    },
    demoButtonText: {
      type: String,
      default: null
    },
    activated: {
      type: Boolean,
      default: false,
    },
    showRecurrentParam: {
      type: Boolean,
      default: false
    },
    recurrentParamDisabled: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      recurrentParam: false,
    }
  },

  mounted() {
    if (this.showRecurrentParam) {
      this.recurrentParam = true
    }
    this.$emit("recurrentParamUpdate", this.recurrentParam);
  },

  computed: {
    ageText() {
      if (this.course.ages && this.course.ages.length > 0) {
        let ages = []
        for (let age of this.course.ages) {
          ages.push(courseApi.getAgeName(age.idage))
        }
        return ages.join(", ")
      }
      return courseApi.getAllAgeNames();
    },

    languageText() {
      if (this.course.idlanguage) return courseApi.getLanguageName(this.course.idlanguage)
      return "-";
    },

    difficlty() {
      if (this.course.difficulty) return courseApi.getDifficultyName(this.course.difficulty).toLowerCase()
      return "easy";
    },

    hasPrevPrice() {
      return (this.priceBefore && this.priceBefore > 0);
    },

    showAdditionalPackage() {
      /*if (this.hideAdd) return false
      return this.course.additional_package_enabled;*/
      return false
    },

    price() {
      if (this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.additional_package_price
      if (!this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.full_price
      return this.course.price
    },

    priceBefore() {
      if (this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.additional_package_price_before
      if (!this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.full_price_before
      return this.course.pricebefore
    },

    showPrice() {
      return true // !this.course.ordered
    },

    buttonText() {
      if (this.course.ordered) {
        if (!this.course.isAdditionalPackage && this.activated && this.course.additional_package_price > 0) return this.$t('buy');
        return this.$t('go_to');
      } else if (this.course.preorder) {
        return this.$t('preorder');
      } else if (parseInt(this.course.price) === 0) {
        return this.$t('subscribe');
      }
      return this.$t('buy');
    }

  },

  watch: {
    activated() {
      this.$emit("additionalChange", this.activated);
    },
    showRecurrentParam(val) {
      this.recurrentParam = val
      this.$emit("recurrentParamUpdate", this.recurrentParam);
    },
  },

  methods: {
    order() {
      this.$emit('order', this.course, this.activated)
    },

    demo() {
      this.$emit('demo')
    },

    stripHtml(html) {
      // Create a new div element
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || "";
    },
    recurrentParamUpdate() {
      this.$emit("recurrentParamUpdate", this.recurrentParam);
    },
  },

  filters: {
    formatPrice: function (value) {
      return numeral(value).format("0,0.00").replace(/\.0+$/, '').replace(/,/g, '\u00A0')
    }
  }
}
</script>

<style scoped>
.h2kurs {
  cursor: pointer;
}

.course-logo-link {
  display: inline-block;
}

.course-logo-link-div {
  text-align: center;
}

.course_ordered_price:hover {
  opacity: 0.3;
}

.course_ordered_price {
  opacity: 0.2;
}

@media (max-width: 580px) {
  .easy {
    margin: 0 auto;
  }
}


</style>

<style src="@/assets/hometeacher/css/main.css">
</style>
